import unlockSplashCircles from '@/assets/unlock-splash-circles.png'

/**
 * Splash-style cover shown while the app is biometrically locked and no
 * failure/lockout screen applies: initial readiness check, just-locked
 * (this is what the iOS app-switcher snapshot captures), and while the
 * native Face ID sheet is in flight (the sheet animates on top of it).
 *
 * The gradient is a fixed-brand color and the circles are a translucent
 * design export — intentionally not themed.
 */
export function UnlockSplash() {
  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center bg-[image:var(--gradient-grape-deep)]">
      <img src={unlockSplashCircles} alt="" className="w-[227px]" />
    </div>
  )
}
